"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "w-full 2xl:container mx-auto p-4 flex flex-col" };
const _hoisted_2 = { class: "filters justify-between lg:items-end" };
const _hoisted_3 = { class: "flex flex-col md:flex-row gap-4" };
const _hoisted_4 = { class: "stocks flex flex-col lg:flex-row gap-4" };
const vue_3 = require("vue");
const vue_router_1 = require("vue-router");
const i18n_1 = require("../../common/i18n");
const DropdownInputItem_1 = __importDefault(require("../../components/Form/DropdownInput/DropdownInputItem"));
const DropdownInput_vue_1 = __importDefault(require("../../components/Form/DropdownInput/DropdownInput.vue"));
const tyre_search_1 = require("../../components/ProductSearch/tyre-search");
const SearchInput_vue_1 = __importDefault(require("../../components/Form/SearchInput/SearchInput.vue"));
const Form_1 = require("../../components/Form");
const shop_1 = require("../../common/utils/shop");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const productFilterStore_1 = require("../../stores/product/filter/productFilterStore");
const ShopConfig_1 = require("../../common/utils/ShopConfig");
exports.default = (0, vue_1.defineComponent)({
    __name: 'AdminPriceAndStockChecker',
    setup(__props) {
        var _a, _b, _c, _d, _e, _f;
        const router = (0, vue_router_1.useRouter)();
        const productFilterValueStore = (0, productFilterStore_1.useProductFilterStore)();
        const companyData = ShopConfig_1.ShopConfig.getCompanyData();
        const priceListFields = (0, vue_3.ref)([
            {
                key: "price_type",
                label: (_a = (0, i18n_1.trans)("price_type", "Price Type", "price_checker")) !== null && _a !== void 0 ? _a : "Price Type",
                value: "price_type",
            },
            {
                key: "web_database",
                label: (_b = (0, i18n_1.trans)("web_database", "Web Database", "price_checker")) !== null && _b !== void 0 ? _b : "Web Database",
                value: "web_database",
            },
            {
                key: "csv",
                label: (_c = (0, i18n_1.trans)("csv", "CSV", "price_checker")) !== null && _c !== void 0 ? _c : "CSV",
                value: "csv",
            },
            {
                key: "ax",
                label: (_d = (0, i18n_1.trans)("ax", "AX", "price_checker")) !== null && _d !== void 0 ? _d : "AX",
                value: "ax",
            },
            {
                key: "actions",
                label: "",
            },
        ]);
        const stockListFields = (0, vue_3.ref)([
            {
                key: "stock_type",
                label: (_e = (0, i18n_1.trans)("stock_type", "Stock Type", "price_checker")) !== null && _e !== void 0 ? _e : "Stock Type",
                value: "stock_type",
            },
            {
                key: "stock",
                label: (_f = (0, i18n_1.trans)("stock", "Stock", "price_checker")) !== null && _f !== void 0 ? _f : "Stock",
                value: "stock",
            },
        ]);
        const siteStockItems = (0, vue_3.ref)([]);
        const otherStockItems = (0, vue_3.ref)([]);
        const mainCategoryItems = (0, vue_3.ref)([
            new DropdownInputItem_1.default('manufacturerSku', `${(0, i18n_1.trans)('manufacturerSku', 'Manufacturer sku', 'price_checker')}`),
            new DropdownInputItem_1.default('ean', `${(0, i18n_1.trans)('ean', 'EAN', 'price_checker')}`),
            new DropdownInputItem_1.default('id', `${(0, i18n_1.trans)('id', 'Marso id', 'price_checker')}`),
        ]);
        const form = (0, vue_3.ref)(Object.assign({}));
        form.value = Object.assign(form.value, tyre_search_1.skuSearchForm);
        const idSearchInput = (0, vue_3.ref)(null);
        const manufacturerSkuSearchInput = (0, vue_3.ref)(null);
        const eanSearchInput = (0, vue_3.ref)(null);
        const mainCategorySelectedItem = (0, vue_3.ref)("id");
        const ids = (0, vue_3.ref)([]);
        const eans = (0, vue_3.ref)([]);
        const manufacturerSkus = (0, vue_3.ref)([]);
        const customerId = (0, vue_3.ref)('');
        const priceRows = (0, vue_3.ref)([]);
        const priceTableItems = (0, vue_3.computed)(() => priceRows.value.map(row => ({
            price_type: row.label,
            web_database: row.web,
            csv: row.csv,
            ax: row.ax,
        })));
        const idSelected = (selectedIdOption) => {
            form.value.id = selectedIdOption.value;
        };
        const eanSelected = (selectedEanOption) => {
            form.value.ean = selectedEanOption.value;
        };
        const manufacturerSkuSelected = (selectedManufacturerSkuOption) => {
            form.value.manufacturerSku = selectedManufacturerSkuOption.value;
        };
        const idReset = () => {
            delete form.value.id;
            delete form.value.ids;
        };
        const manufacturerSkuReset = () => {
            delete form.value.manufacturerSku;
            delete form.value.manufacturerSkus;
        };
        const eanReset = () => {
            delete form.value.ean;
            delete form.value.eans;
        };
        const getProductPrices = async () => {
            try {
                const priceCheck = await (0, fetch_1.default)(router.resolve({ name: 'shop_products_price_check', query: { customerId: customerId.value, ...form.value } }).href, { method: 'GET' });
                const priceTypes = [
                    { type: 'net', label: (0, i18n_1.trans)('net_price_label', 'Nettó listaár', 'price_checker') },
                    { type: 'net_retail', label: (0, i18n_1.trans)('net_retail_label', 'Nettó kisker ár', 'price_checker') },
                    { type: 'net_discount', label: (0, i18n_1.trans)('net_discount_label', 'Nettó kedvezményes nagyker ár', 'price_checker') },
                    { type: 'net_discount_retail', label: (0, i18n_1.trans)('net_discount_retail_label', 'Nettó kedvezményes kisker ár', 'price_checker') },
                ];
                const rows = priceTypes.map(price => {
                    var _a, _b, _c;
                    const webPrice = (_a = priceCheck.database) === null || _a === void 0 ? void 0 : _a[price.type];
                    const csvPrice = (_b = priceCheck.csv) === null || _b === void 0 ? void 0 : _b[price.type];
                    const axPrice = (_c = priceCheck.axapta) === null || _c === void 0 ? void 0 : _c[price.type];
                    return {
                        type: price.type,
                        label: price.label,
                        web: !webPrice || webPrice === 0 ? "-" : (0, shop_1.formatPrice)(webPrice, companyData.currencyCode),
                        csv: !csvPrice || csvPrice === 0 ? "-" : (0, shop_1.formatPrice)(csvPrice, companyData.currencyCode),
                        ax: !axPrice || axPrice === 0 ? "-" : (0, shop_1.formatPrice)(axPrice, priceCheck.axapta.currencyCode),
                    };
                });
                priceRows.value = rows;
            }
            catch (error) {
                console.error('Error in get product price check:', error);
                priceRows.value = [];
            }
        };
        const getProductStocks = async () => {
            try {
                const stocks = await (0, fetch_1.default)(router.resolve({ name: 'shop_products_stock_check', query: { customerId: customerId.value, ...form.value } }).href, { method: 'GET' });
                const stockTypes = [
                    { key: 'siteStocks', section: 'siteStocks' },
                    { key: 'expressStock', section: 'expressStock' },
                    { key: 'localStock', section: 'localStock' },
                    { key: 'localWholesaleStock', section: 'localWholesaleStock' },
                    { key: 'supplierStock', section: 'supplierStock' },
                    { key: 'supplierRealtimeStock', section: 'supplierRealtimeStock' },
                ];
                for (const { key, section } of stockTypes) {
                    if (stocks && stocks[key] && typeof stocks[key] === 'object') {
                        const entries = Object.entries(stocks[key]);
                        for (const [site, stock] of entries) {
                            const item = {
                                stock_type: site,
                                stock: typeof stock === 'number' ? stock : String(stock),
                            };
                            // section alapján eldöntjük, hogy melyik táblázatba kerüljön az elem
                            if (section === 'siteStocks') {
                                siteStockItems.value.push(item);
                            }
                            else {
                                otherStockItems.value.push(item);
                            }
                        }
                    }
                }
            }
            catch (error) {
                console.error('Error in get product stock check:', error);
                siteStockItems.value = [];
                otherStockItems.value = [];
            }
        };
        (0, vue_3.onBeforeMount)(async () => {
            try {
                await productFilterValueStore.getProductFilters(router, {});
                ids.value = productFilterValueStore.idSearchInputOptions;
                eans.value = productFilterValueStore.eanSearchInputOptions;
                manufacturerSkus.value = productFilterValueStore.manufacturerSkuSearchInputOptions;
            }
            catch (error) {
                console.error('Error fetching IDs:', error);
                ids.value = [];
            }
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                            modelValue: mainCategorySelectedItem.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((mainCategorySelectedItem).value = $event)),
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('category', 'Category', 'price_checker'),
                            items: mainCategoryItems.value,
                            "disable-deselect": ""
                        }, null, 8, ["modelValue", "placeholder", "items"]),
                        (mainCategorySelectedItem.value === 'id')
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SearchInput_vue_1.default, {
                                key: 0,
                                ref_key: "idSearchInput",
                                ref: idSearchInput,
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('id_searcher_placeholder', 'ID', 'price_checker'),
                                options: ids.value,
                                onSelected: idSelected,
                                onReset: idReset
                            }, null, 8, ["placeholder", "options"]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (mainCategorySelectedItem.value === 'ean')
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SearchInput_vue_1.default, {
                                key: 1,
                                ref_key: "eanSearchInput",
                                ref: eanSearchInput,
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('ean_searcher_placeholder', 'SKU', 'price_checker'),
                                options: eans.value,
                                onSelected: eanSelected,
                                onReset: eanReset
                            }, null, 8, ["placeholder", "options"]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (mainCategorySelectedItem.value === 'manufacturerSku')
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SearchInput_vue_1.default, {
                                key: 2,
                                ref_key: "manufacturerSkuSearchInput",
                                ref: manufacturerSkuSearchInput,
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('manufacturer_sku_searcher_placeholder', 'manufacturerSku', 'price_checker'),
                                options: manufacturerSkus.value,
                                onSelected: manufacturerSkuSelected,
                                onReset: manufacturerSkuReset
                            }, null, 8, ["placeholder", "options"]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            type: "text",
                            name: "id",
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('customer_id_placeholder', 'Customer ID', 'price_checker'),
                            required: "",
                            border: "",
                            icon: "marso-icon-user",
                            modelValue: customerId.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((customerId).value = $event))
                        }, null, 8, ["placeholder", "modelValue"])
                    ]),
                    (0, vue_2.createElementVNode)("button", {
                        class: "btn btn-rounded btn-primary",
                        onClick: _cache[2] || (_cache[2] = ($event) => (getProductPrices(),
                            getProductStocks()))
                    }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("search", "Search", "price_checker")), 1)
                ]),
                (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                    fields: priceListFields.value,
                    items: (0, vue_2.unref)(priceTableItems),
                    condensed: "",
                    stripes: ""
                }, null, 8, ["fields", "items"]),
                (0, vue_2.createElementVNode)("div", _hoisted_4, [
                    (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                        class: "w-full lg:w-1/2",
                        fields: stockListFields.value,
                        items: siteStockItems.value,
                        condensed: "",
                        stripes: ""
                    }, null, 8, ["fields", "items"]),
                    (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                        class: "w-full lg:w-1/2",
                        fields: stockListFields.value,
                        items: otherStockItems.value,
                        condensed: "",
                        stripes: ""
                    }, null, 8, ["fields", "items"])
                ])
            ]));
        };
    }
});
